import React from 'react';
import LatestNewsAside from '../../../../shared/LatestNewsAside';
import ContentAsideProgramHistory from './ContentAsideProgramHistory';

type ContentAsideProps = {
  content: any;
};

export default function ContentAside({ content }: ContentAsideProps) {
  return (
    <aside className="content-view__aside" aria-label="Conteúdos relacionados">
      <ContentAsideProgramHistory content={content} />
      <LatestNewsAside />
    </aside>
  );
}
